import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import en from "./en.json";
import sr from "./sr.json";

const dictionaries = {
  en,
  sr,
};

const I18nContext = createContext(null);

function getNestedValue(source, path) {
  return path.split(".").reduce((value, key) => {
    if (value === undefined || value === null) return undefined;
    return value[key];
  }, source);
}

function getInitialLanguage() {
  const savedLanguage = window.localStorage.getItem("two-guys-language");
  return dictionaries[savedLanguage] ? savedLanguage : "sr";
}

function I18nProvider({ children }) {
  const [language, setLanguage] = useState(getInitialLanguage);
  const translations = dictionaries[language];

  useEffect(() => {
    window.localStorage.setItem("two-guys-language", language);
    document.documentElement.lang = language;
  }, [language]);

  const value = useMemo(() => {
    const t = (path) => {
      const translatedValue = getNestedValue(translations, path);
      return translatedValue === undefined ? path : translatedValue;
    };

    return {
      language,
      setLanguage,
      t,
      translations,
    };
  }, [language, translations]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

function useI18n() {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("useI18n must be used inside I18nProvider");
  }
  return context;
}

export { I18nProvider, useI18n };
